import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const boundaryFormTypeSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryForm.type;
export const useBoundaryFormType = () => useSelector(boundaryFormTypeSelector);

const boundaryFormModeSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryForm.mode;
export const useBoundaryFormMode = () => useSelector(boundaryFormModeSelector);

const boundaryFormPreselectedBoundaryGroupCodenameSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryForm.preselectedBoundaryGroupCodename;
export const useBoundaryFormPreselectedBoundaryGroupCodename = () => useSelector(boundaryFormPreselectedBoundaryGroupCodenameSelector);

const boundaryFormPreselectedBoundaryTerritoryTypeSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryForm.preselectedBoundaryTerritoryType;
export const useBoundaryFormPreselectedBoundaryTerritoryType = () => useSelector(boundaryFormPreselectedBoundaryTerritoryTypeSelector);

const boundaryFormPreselectedDemographicNameSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryForm.preselectedDemographicName;
export const useBoundaryFormPreselectedDemographicName = () => useSelector(boundaryFormPreselectedDemographicNameSelector);
